export enum EventStatusEnum {
  All = 0,
  Upcoming,
  Completed,
  Canceled,
}

export enum EventStatusTabKeysEnum {
  Upcoming = 'upcoming',
  Completed = 'completed',
  Cancelled = 'cancelled',
}
